import React from 'react';

function NotFound() {
  //write code here

  return <h1>404 NOT FOUND PAGE</h1>;
}

export default NotFound;
